import { useCallback, useEffect, useState } from 'react'
import { useMiddlewareClient } from '@/hooks/useMiddlewareClient'
import { logError } from './errorUtils'

export type CareCoordinator = {
  id: string
  name: string
  email?: string
}

type ListResponse = {
  practitioners: CareCoordinator[]
}

export function useCareCoordinators(enabled: boolean) {
  const middleware = useMiddlewareClient()
  const [coordinators, setCoordinators] = useState<CareCoordinator[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchCoordinators = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const result = (await middleware.get('/practitioner/care-coordinators')) as ListResponse
      setCoordinators(result.practitioners ?? [])
    } catch (err) {
      logError('Fetch care coordinators', err)
      setError('Unable to load care coordinators.')
    } finally {
      setLoading(false)
    }
  }, [middleware])

  useEffect(() => {
    if (enabled) {
      void fetchCoordinators()
    }
  }, [enabled, fetchCoordinators])

  return { coordinators, loading, error, refetch: fetchCoordinators }
}
